// extracted by mini-css-extract-plugin
export default {"sectionHeaderSecond":"headerSecond_sectionHeaderSecond__xlrDF"};